















































import Vue from "vue";
import BaseModalWindow from "@/app/shared/components/base/BaseModalWindow.vue";
import BaseButton from "@/app/shared/components/base/BaseButton.vue";

export default Vue.extend({
  name: "BaseConfirm",
  components: { BaseModalWindow, BaseButton },
  data: function () {
    return {};
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: "",
    },
    acceptTitle: {
      type: String,
      default: "Yes",
    },
    discardTitle: {
      type: String,
      default: "No",
    },
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {
    accept() {
      this.$emit("accept");
      this.$emit("close");
    },
    discard() {
      this.$emit("discard");
      this.$emit("close");
    },
  },
});
